module.exports = __webpack_public_path__ + "cd455783/img/comment-question-icon.7dd26e04.svg";